import React from "react";
import {authService} from "./auth";
import {getCDNUrl} from "./commons/CommonFunctions";
import {Redirect, Link} from "react-router-dom";
import TopPostBoxComponent from "./TopPostBoxComponent";
import uuid from "react-uuid";
class TopPostBox extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            userData: authService.getUserDetailsFromLocalStorage(),
        }
    }

    getOptimizedImage(personalInfo) {
        if (personalInfo.resizedProfileImages && personalInfo.resizedProfileImages['200x200'] != null) {
            return personalInfo.resizedProfileImages['200x200'];
        }
        return personalInfo.profileImage;
    }

    componentWillUnmount() {
        window.$('#toppostwrap').modal('hide');
        window.$('#postblog').modal('hide');
        window.$('#postlink').modal('hide');
        window.$('#addpostpop').modal('hide');
        window.$('#blogpostpreviewwrap').modal('hide');
    }

    redirectToProfile = (customUrl) => {
        this.setState({redirectToProfile: customUrl});
    }

    render() {
        return (
            <>
                {this.state.redirectToProfile && <Redirect push to={"/profile/" + this.state.redirectToProfile}/>}
                <section className="toppostwrap">
                    <figure className="userimg" onClick={(e) => {
                        e.preventDefault();
                        this.redirectToProfile(this.state.userData.customUrl)
                    }}>
                        <img src={this.state.userData.profileImage ?
                            getCDNUrl(this.getOptimizedImage(this.state.userData)) : (this.state.userData.type !== "COMPANY" ? "https://cdn.dscovr.com/images/users1.png" : "https://cdn.dscovr.com/images/DefaultBusiness.png")}
                             alt=""/>
                    </figure>
                    {/* <div className="toppostinn">
                        <div className="toppostWhatsTrending">
                            <TopPostBoxComponent key={uuid()} activeTab={this.props?.selectedTab} />

                            <div className="tpbfieldblock">
                                <div className="tpbfieldlogo">
                                    <img src="https://cdn.dscovr.com/images/quotes-logo.webp"
                                         onError={(e) => {
                                             e.target.onerror = null;
                                             e.target.src = "https://cdn.dscovr.com/images/quotes-logo.png"
                                         }}
                                         alt=""/>
                                </div>
                                <div className="tpbfield">
                                    <button
                                        data-target="#toppostwrap"
                                        className="btn"
                                        data-toggle="modal">
                                        Post Something New!
                                    </button>
                                </div>                               
                            </div>
                            <div className="tpblinks">
                                <a href="#postblog" className="btn" data-toggle="modal">
                                    <i className="iBlog"/>Blog
                                </a>
                                <a href="#postlink" className="btn" data-toggle="modal">
                                    <i className="iLink_Post"/>Link
                                </a>
                            </div>
                        </div>
                    </div> */}
                    
                    <a href="#addpostpop" className="btn" data-toggle="modal">
                        <i className="iAddPost"/>Post
                    </a>
                </section>
            </>
        );
    }
}

export default TopPostBox;
